import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { approvePairingByCode } from "../../services/linkedDeviceService";
import Button from "./Button";
import Input from "./Input";
import Modal from "./Modal";
import { color } from "../../styles/theme";
import { toast } from "react-toastify";

// Links a new checkin device (the PSA phone app) using the short code shown
// on its screen when it requests pairing — same code that's also in its QR,
// for whoever scans it from the phone side instead.
const LinkDeviceModal = ({ onClose, onLinked }) => {
  const { t } = useTranslation("common");
  const [shortCode, setShortCode] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!shortCode.trim()) {
      toast.warning(t("linkDeviceModal.enterCodeWarning"));
      return;
    }

    setLoading(true);
    try {
      const res = await approvePairingByCode(shortCode.trim(), deviceName.trim() || undefined);
      if (res.data?.Success) {
        toast.success(res.data?.Message || t("linkDeviceModal.linkSuccess"));
        onLinked();
        onClose();
      } else {
        toast.error(res.data?.Message || t("linkDeviceModal.linkError"));
      }
    } catch (err) {
      toast.error(err.response?.data?.Message || t("linkDeviceModal.linkError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t("linkDeviceModal.title")}
      onClose={onClose}
      busy={loading}
      maxWidth={440}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading} type="button">{t("actions.cancel")}</Button>
          <Button onClick={handleSubmit} disabled={loading}>{loading ? t("linkDeviceModal.linking") : t("linkDeviceModal.link")}</Button>
        </>
      }
    >
      <p style={s.hint}>
        {t("linkDeviceModal.hint")}
      </p>

      <form onSubmit={handleSubmit}>
        <Input
          label={t("linkDeviceModal.pairingCodeLabel")}
          value={shortCode}
          onChange={(e) => setShortCode(e.target.value.toUpperCase())}
          placeholder={t("linkDeviceModal.pairingCodePlaceholder")}
          required
          style={{ letterSpacing: 2, fontWeight: 700, textTransform: "uppercase" }}
        />
        <Input
          label={t("linkDeviceModal.deviceNameLabel")}
          value={deviceName}
          onChange={(e) => setDeviceName(e.target.value)}
          placeholder={t("linkDeviceModal.deviceNamePlaceholder")}
          style={{ marginBottom: 0 }}
        />
      </form>
    </Modal>
  );
};

const s = {
  hint: { fontSize: 12.5, color: color.textSecondary, lineHeight: 1.5, margin: "0 0 18px" },
};

export default LinkDeviceModal;
